import { createFileRoute } from "@tanstack/react-router";
import { catalogProviderRoute } from "@/app-clients/catalog-detail/provider-route-data";
import { ProviderRoutePage } from "@/app-clients/catalog-detail/provider-route";

export const Route = createFileRoute("/provider/$providerId")({
    ssr: catalogProviderRoute.ssr,
    loader: catalogProviderRoute.loader,
    head: catalogProviderRoute.head,
    component: ProviderRoutePage,
});
